module.exports = __webpack_public_path__ + "src/app/images/city-centre-logo.png";